import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IsfV1Model } from '@data-layer/models/isf-v1';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { ICustomError } from '../../interfaces';
import { BondRequestModel } from '@data-layer/models/common';

@Component({
  selector: 'status-error',
  templateUrl: './status-error.component.html',
  styleUrls: ['./status-error.component.scss'],
})
export class StatusErrorComponent implements OnInit {
  @Input() public error: ICustomError;
  @Input() public currIsf: IsfV1Model;
  @Input() public currES: EntrySummaryModel;
  @Input() public currBondRequest: BondRequestModel;
  @Input() public isDelivery: boolean;
  @Output() public goToEdit: EventEmitter<any> = new EventEmitter<any>();

  public isCustomError: boolean = false;
  private isIsf: boolean = true;
  private isES: boolean = false;
  private isBondRequest: boolean = false;

  constructor() {}

  public ngOnInit(): void {
    this.isIsf = !!(this.currIsf && this.currIsf.id);
    this.isES = !!(this.currES && this.currES.id) && !this.isDelivery;
    this.isBondRequest = !!(this.currBondRequest && this.currBondRequest.id);
    if (!!this.error && !!this.error.messages) {
      this.isCustomError = true;
    }
  }

  public get referenceNumber(): string {
    return this.isIsf
      ? this.currIsf.referenceNumber
      : this.isES || this.isDelivery
      ? this.currES.referenceNumber
      : this.isBondRequest
      ? this.currBondRequest.referenceNumber
      : '';
  }

  public get code() {
    return this.isIsf ? 'LABELS.ISF' : this.isES ? 'LABELS.ENTRY_SUMMARY' : this.isDelivery ? 'MESSAGE_CODE.DELIVERY' : '';
  }

  public get errorText(): string {
    return this.isIsf
      ? 'LABELS.SOMETHING_DONT_WORK_TITLE'
      : this.isES
      ? 'INFO.RESULT.ERROR.TEXT_ES'
      : this.isDelivery
      ? 'INFO.RESULT.ERROR.TEXT_DELIVERY'
      : '';
  }

  public get errorTitle(): string {
    if (this.isCustomError && this.error.title) {
      return this.error.title;
    }
    return this.isIsf || this.isES ? 'INFO.RESULT.ERROR.TITLE_1' : this.isDelivery ? 'ERROR.TITLE_NOT_SEND' : '';
  }

  public goToSummary() {
    this.goToEdit.emit();
  }
}
